export type ThemeMode = 'light' | 'dark';

export function getThemeByTier(tierName?: string) {
  return tierName?.toLowerCase() === 'exclusive' ? 'dark' : 'light';
}

export function getClassWithTheme(className: string, theme?: ThemeMode) {
  if (theme === 'dark') return `${className} ${className}--dark`;

  return className;
}
